import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../core/data/redux/store";

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const { isAuthenticated, role } = useSelector((state: RootState) => state.auth);
  const token = localStorage.getItem("authToken");

  if (!isAuthenticated || !token) {
    //return <Navigate to="/" replace />;
        return <Navigate to="/#/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role || "")) {
    // return <Navigate to="/" replace />;
      return <Navigate to="/#/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
